import React, { useEffect, useState } from 'react'
import NavbarContainer from '../components/Navbar/Navbar'
import TotalSidebar from '../components/TotalSidebar/TotalSidebar'
import CartContainer from '../components/CartContainer/CartContainer'
import Footer from '../components/Footer/Footer'
import PageHeader from '../components/PageHeader/PageHeader'
import { Col, Container, Row } from 'react-bootstrap'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCart } from '../hook/cart'

function Cart() {
  const userinfo = useSelector((state) => state);
  const cart = useSelector((state) => state.cartReducer.cart);
  const dispatch=useDispatch()


  useEffect(() => {
    dispatch(fetchCart());

    // const getCart = async () => {
    //   await axios
    //     .get(`https://nanosoft.technology/outlaw/api/cart`, {
    //       headers: {
    //                         Authorization: `Bearer ${userinfo?.auth?.access_token}`
    //       }
    //     })
    //     .then(async (res) => {
    //       setCart(res.data.data);

    //     })
    //     .catch((error) => {

    //       console.log(error.response.data);


    //     });
    // }
    // getCart()
  }, [])
  return (
    <>
      <NavbarContainer />

      <Container className='py-5'>
        {cart&&cart.items&&cart.items.length!==0?
        <Row>

          <Col md={8}>
            <CartContainer
              items={cart.items}
            />
          </Col>
          <Col md={4}>
            <TotalSidebar
            item={cart}
            />

          </Col>
        </Row>
        :
        <Row>
          <p className='fw-bold text-danger fs-4 text-center'>Cart is empty</p>
        </Row>
}
      </Container>
      <Footer />
    </>)
}

export default Cart